"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getBoxShadow = require("./getBoxShadow");
Object.keys(_getBoxShadow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getBoxShadow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getBoxShadow[key];
    }
  });
});
var _getShadeBackground = require("./getShadeBackground");
Object.keys(_getShadeBackground).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getShadeBackground[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getShadeBackground[key];
    }
  });
});
var _getShadeBorder = require("./getShadeBorder");
Object.keys(_getShadeBorder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getShadeBorder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getShadeBorder[key];
    }
  });
});
var _getShadeClearIconColor = require("./getShadeClearIconColor");
Object.keys(_getShadeClearIconColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getShadeClearIconColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getShadeClearIconColor[key];
    }
  });
});
var _getShadeClearIconSize = require("./getShadeClearIconSize");
Object.keys(_getShadeClearIconSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getShadeClearIconSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getShadeClearIconSize[key];
    }
  });
});
var _getShadeRootSize = require("./getShadeRootSize");
Object.keys(_getShadeRootSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getShadeRootSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getShadeRootSize[key];
    }
  });
});
